import BasePhoto from './BasePhoto';

export default class Photo extends BasePhoto {
  public photographer: string;
  public description: string;
}
